<template>
  <div class="comp-change-password">
    <jw-modal :visible="data.visible" @ok="handleOk" @cancel="handleCancel" title-align="start" width="420px" :mask-closable="false" unmount-on-close :ok-loading="loading" ok-text="提交">
      <template #title> 修改密码</template>
      <jw-form :model="data.form" label-align="left" auto-label-width ref="passwordForm" @submit="handleSubmit" class="select-item">
        <jw-form-item label="原密码" field="oldPass" :rules="pwdRules" :validate-trigger="['blur', 'change']" auto-label-width asterisk-position="end">
          <jw-input-password v-model.trim="data.form.oldPass" placeholder="请输入原密码" @blur="checkOldPwd" :style="{ width: '320px' }" allow-clear />
        </jw-form-item>
        <jw-form-item label="短信验证码" field="code" :rules="codeRules" :validate-trigger="['blur']" auto-label-width asterisk-position="end">
          <jw-input :style="{ width: '212px' }" style="margin-right: 8px" v-model.trim="data.form.code" @change="checkVerifyCode" placeholder="请输入验证码" allow-clear> </jw-input>
          <jw-button v-if="timeLeft" :disabled="timeLeft" size="small" type="outline">重新发送({{ timeLeft }})</jw-button>
          <jw-button v-else @click.stop="getVerifyCode()" size="small" type="outline">获取验证码</jw-button>
        </jw-form-item>
        <jw-form-item label="新密码" field="newPass" :rules="rulesNewPassword" :validate-trigger="['blur', 'change']" auto-label-width asterisk-position="end">
          <jw-input-password v-model.trim="data.form.newPass" placeholder="密码要求8-16位，数字+字母" :style="{ width: '320px' }" allow-clear />
        </jw-form-item>
        <jw-form-item label="确认新密码" field="confirmPass" :rules="rulesConfirmpassword" :validate-trigger="['blur', 'change']" auto-label-width asterisk-position="end">
          <jw-input-password v-model.trim="data.form.confirmPass" placeholder="密码要求8-16位，数字+字母" :style="{ width: '320px' }" allow-clear />
        </jw-form-item>
      </jw-form>
      <template #footer>
        <jw-space>
          <jw-button @click="handleCancel" size="small" type="dashed">取消</jw-button>
          <jw-button @click="handleOk" size="small" :disabled="data.oldPassType && data.checkCodeResult ? false : true" :type="data.oldPassType && data.checkCodeResult ? 'primary' : 'dashed'">提交</jw-button>
        </jw-space>
      </template>
    </jw-modal>
  </div>
</template>

<script setup>
import _ from 'lodash';
import { reactive, ref, onMounted } from 'vue';
import { userService } from '@/api/';
import { useUserStore } from '@/store';
import md5 from 'js-md5';
import { Message } from '@arco-design/web-vue';
import useLoading from '@/hooks/loading';
import useCountDownTime from '@/hooks/countdownTime';
const { timeLeft, startCountdown, checkCountDownTime, serializeCode } = useCountDownTime();
const data = reactive({
  visible: false,
  form: {
    oldPass: '',
    newPass: '',
    confirmPass: '',
    code: ''
  },
  oldPassType: false,
  phoneNumber: null
});
const userStore = useUserStore();
const { loading, setLoading } = useLoading(false);
const { userInfo } = useUserStore();
// 打开弹窗
const openDialog = () => {
  data.form.oldPass = '';
  data.form.newPass = '';
  data.form.confirmPass = '';
  data.visible = true;
};
// 关闭弹窗
const handleCancel = () => {
  data.visible = false;
};
const passwordForm = ref();
// 确定按钮
const handleOk = () => {
  if (data.oldPassType === false) return;
  passwordForm.value.handleSubmit();
};

const containsLetterAndNumber = (str) => {
  let hasLetter = false;
  let hasNumber = false;
  for (var char of str) {
    if (/[a-zA-Z]/.test(char)) {
      hasLetter = true;
    }
    if (/[0-9]/.test(char)) {
      hasNumber = true;
    }
    if (hasLetter && hasNumber) {
      return true;
    }
  }
  return false;
};

const rulesFun = (value, cb) => {
  if (!value) {
    cb('请输入确认新密码');
  } else {
    if (data.form.newPass?.length < 8) {
      cb('密码至少需要8位哦');
    }
    if (data.form.newPass?.length > 16) {
      cb('密码最大需要16位哦');
    }
    if (!containsLetterAndNumber(value)) {
      cb('密码要求8-16位，数字+字母');
    }
    if (data.form.newPass !== data.form.confirmPass) {
      cb('2次输入定的密码不一致，请检查');
    }
    if (data.form.newPass === data.form.confirmPass) {
      passwordForm.value?.clearValidate(['newPass']);
      passwordForm.value?.clearValidate(['confirmPass']);
    }
  }
};

const rulesNewPassword = [
  {
    required: true,
    validator: async (value, cb) => {
      rulesFun(value, cb);
    }
  }
];
const rulesConfirmpassword = [
  {
    required: true,
    validator: async (value, cb) => {
      rulesFun(value, cb);
    }
  }
];

// { required: true, message: '请输入原密码' },
// { minLength: 8, message: '密码至少需要8位哦' }
const pwdRules = [
  {
    required: true,
    validator: async (value, cb) => {
      if (!value) {
        cb('请输入原密码!');
      } else {
        if (value.length < 8) {
          cb('密码至少需要8位哦!');
        }
      }
    }
  }
];
// 校验原密码
const checkOldPwd = _.debounce(async () => {
  try {
    // type 1, 登录验证码, 3, 重置密码, ,4, 初次填写手机号,5, 忘记密码找回
    const json = await userService.originalPassword({ userId: userInfo.id, oldPass: md5(data.form.oldPass) });
    if (!json.error) {
      console.log('originalPassword', json);
      data.oldPassType = json.result.checkResult;
      if (data.oldPassType === false) {
        passwordForm.value.setFields({
          oldPass: {
            status: 'error',
            message: '原密码不正确'
          }
        });
      } else {
        Message.success('原密码正确');
      }
    } else {
      Message.error('验证失败');
    }
  } catch (e) {
    Message.error(e.message || '验证失败');
  }
}, 100);

const codeRules = [
  {
    required: true,
    validator: async (value, cb) => {
      if (!value) {
        cb('请输入验证码!');
      }
    }
  }
];
// 校验验证码
const checkVerifyCode = _.debounce(async () => {
  try {
    if (!data.form.code) return;
    // type 1, 登录验证码, 3, 重置密码, ,4, 初次填写手机号,5, 忘记密码找回
    const json = await userService.checkVerifyCode({ mobile: data.form.phoneNumber, serializeCode: serializeCode.value, verifyCode: data.form.code });
    if (!json.error) {
      data.checkCodeResult = json.result?.checkResult;
      if (data.checkCodeResult === false) {
        passwordForm.value.setFields({
          code: {
            status: 'error',
            message: '验证码不正确，请检查重试'
          }
        });
      }
      return json.result?.checkResult;
    } else {
      Message.error('验证失败');
    }
  } catch (e) {
    Message.error(e.message || '验证失败');
  }
}, 100);

const getVerifyCode = () => {
  startCountdown('saveCountDownTime', data.form.phoneNumber, 6);
};

// 表单提交
const handleSubmit = ({ values, errors }) => {
  console.log('values', values);
  console.log('errors', errors);
  if (errors) {
    const errorArray = {};
    Object.values(errors).forEach((key, index) => {
      errorArray[key.field] = { status: 'error', message: '' };
      Object.values(errorArray).forEach((i, ind) => {
        if (index === ind) {
          i.message = key.message;
        }
      });
    });
    passwordForm.value.setFields(errorArray);
    return;
  }
  if (values.newPass != values.confirmPass) {
    passwordForm.value.setFields({ confirmPass: { status: 'error', message: '两次新密码不一致' } });
    return;
  }
  updatePassword();
};
const updatePassword = async () => {
  setLoading(true);
  try {
    const params = {
      userId: userInfo.id,
      account: data.form.phoneNumber,
      code: data.form.code,
      serializeCode: serializeCode.value,
      oldPass: md5(data.form.oldPass),
      newPass: md5(data.form.newPass),
      confirmPass: md5(data.form.confirmPass)
    };
    const res = await userService.updatePassword(params);
    if (!res.error) {
      Message.success('修改成功');
      handleCancel();
      handleLogout();
    } else {
      Message.error(res.error.msg || '操作失败');
      // passwordForm.value.setFields({ oldPass: { status: 'error', message: '原密码输入错误！请重新输入' } });
    }
    setLoading(false);
  } catch (e) {
    setLoading(false);
    Message.error(e.message || e.statusText || '获取数据失败');
  }
};

// 页面加载时，检查是否有倒计时正在进行
onMounted(() => {
  const phone = userInfo?.mobile;
  data.form.phoneNumber = phone?.replace('+86', '');
  checkCountDownTime('saveCountDownTime');
});

// 退出
const handleLogout = () => {
  userStore.logout();
};
defineExpose({
  openDialog
});
</script>
<style scoped lang="less">
@import './change-password.less';
</style>
